// src/apiAuth.js
// Aggiunge il token di accesso a TUTTE le chiamate verso le API del backend
// (URL che contengono "/api/"), senza toccare le decine di fetch sparse
// nell'app. Se il server risponde 401 su una pagina riservata, la sessione è
// scaduta o non valida: si torna al login.
import { getSession, clearSession, isPublicPath } from './session';

if (typeof window !== 'undefined' && typeof window.fetch === 'function' && !window.__rsFetchPatched) {
  window.__rsFetchPatched = true;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isApi = url.includes('/api/');
    let opts = init;
    if (isApi) {
      const s = getSession();
      if (s?.token) {
        const headers = new Headers((init && init.headers) || (typeof input !== 'string' && input && input.headers) || {});
        if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${s.token}`);
        opts = { ...(init || {}), headers };
      }
    }
    const res = await originalFetch(input, opts);
    if (isApi && res.status === 401 && !url.includes('/api/auth/login')) {
      const path = window.location.pathname;
      if (!isPublicPath(path)) {
        clearSession();
        const next = encodeURIComponent(path + window.location.search);
        window.location.replace(`/login?next=${next}`);
      }
    }
    return res;
  };
}
